riot.tag2('gb-sayt-divider', '<div if="{isVisible()}"></div>', '.gb-stylish gb-sayt-divider div,.gb-stylish [riot-tag="gb-sayt-divider"] div,.gb-stylish [data-is="gb-sayt-divider"] div{ display: block; margin: 3px 10%; border-top: 1px solid #777; }', '', function(opts) {
    this.isVisible = () => this.root.nextElementSibling &&
      this.root.nextElementSibling.querySelector('li') &&
      this.root.previousElementSibling &&
      this.root.previousElementSibling.querySelector('li');
});



/** WEBPACK FOOTER **
 ** ./src/tags/sayt/gb-sayt-divider.tag.html
 **/